module.exports = __webpack_public_path__ + "static/media/2morecoins.a1ddf3ee.png";